import React, { useState, useCallback } from 'react';
import Button from '@hubins/components/Button';
import __ from 'localisation';
import { useMiddleman } from '@hubins/middleman';
import { useHistory } from 'react-router-dom';
import { useNotificationContext } from '@hubins/components/NotificationContext/NotificationContext';

const DeletePortfolioButton = ({ portfolioUuid }) => {
  const middleman = useMiddleman();

  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const { setNotification } = useNotificationContext();

  const deletePortfolio = useCallback(async () => {
    if (window.confirm(__('delete_portfolio_confirmation'))) {
      try {
        setLoading(true);
        await middleman.promiseDelete(`/ql/crm/portfolio/delete/${portfolioUuid}`);
        setNotification({ type: 'success', message: <p>{__('portfolio_deleted')}</p> });
        history.push('/dashboard/clients');
      } catch (e) {
        console.error(e.message);
        setNotification({ type: 'error', message: <p>{e.message}</p> });
        setLoading(false);
      }
    }
  }, [portfolioUuid]);

  return (
    <Button className="danger" icon="Bin by Streamlinehq" iconColor="white" onClick={deletePortfolio} loading={loading} disabled={loading}>
      {__('delete_portfolio')}
    </Button>
  );
};

export default DeletePortfolioButton;